import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataService } from '../../services/data.service';
import { ContextService } from '../../services/context.service';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LegendComponent implements OnInit {
  title: string;
  legentItems: { color: [number, number, number], label: string, css_color: string }[] = [];
  steps = 5;
  constructor(private dataService: DataService, private app: ContextService) {
    this.app.legend = this;
  }

  ngOnInit() {
  }

  redraw() {
    const selectedPropertyGroup = this.app.propertySelector.selectedProperty.group;
    const selectedPropertyName = this.app.propertySelector.selectedProperty.name;
    const maxValue = this.dataService.getGlobalMaxVauleOfDimosDataByPropertyName(selectedPropertyGroup, selectedPropertyName);
    console.log(selectedPropertyGroup, selectedPropertyName, maxValue);
    this.title = `${maxValue}`;
    this.legentItems = [];
    for (let i = 0; i < this.steps; i++) {
      this.legentItems.push({
        color: [255, 0, 0, (i * maxValue / this.steps) / maxValue],
        label: (i * maxValue / this.steps).toString(),
        css_color: `rgba(255,0,0,${(i * maxValue / this.steps) / maxValue})`
      });
    }

    console.log(this.legentItems);

  }

}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/legend/legend.component.ts